import { render } from "./movimentos-status-list.vue?vue&type=template&id=4789f3df"
import script from "./movimentos-status-list.vue?vue&type=script&lang=js"
export * from "./movimentos-status-list.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Administrador\\PhpstormProjects\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__